import {
  ControlBarContainer,
  ControlBarBox,
  ControlBarWrapper,
  ControlBarButtonsBox,
  ControlBarTitleBox,
} from './ControlBar.styles';
import { ReactNode, useState } from 'react';
import { IconButton, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import ArrowBack from '@mui/icons-material/ArrowBack';
import KpiFormulasModal from '../Modals/KpiFolmulasModal/KpiFormulasModal';
import { useTranslation } from 'react-i18next';

export interface IControlButton {
  action?: () => void;
  label?: ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  disabled?: boolean;
  dataTestId?: string;
}
export interface IBottomControlBar {
  leftButton?: IControlButton;
  rightButtons?: IControlButton[];
  title?: ReactNode;
  backButtonAction?: () => void;
  withKpiButton?: boolean;
}

export const ControlButton = ({ label, action, variant, disabled, dataTestId }: IControlButton) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dataTestIdText = typeof label === 'string' ? label : dataTestId;

  return (
    <Button
      variant={variant || 'outlined'}
      onClick={action || (() => navigate(-1))}
      disabled={disabled}
      data-testid={`${dataTestIdText || 'back'}-btn`}
    >
      {label || t('back')}
    </Button>
  );
};

const BackButton = ({ action }: IControlButton) => {
  const navigate = useNavigate();
  return (
    <IconButton aria-label="Back" onClick={action || (() => navigate(-1))}>
      <ArrowBack />
    </IconButton>
  );
};

export const ControlBar = ({
  leftButton,
  rightButtons,
  title,
  backButtonAction,
  withKpiButton = false,
}: IBottomControlBar) => {
  const { t } = useTranslation();
  const [isFormulasModalOpen, setIsFormulasModalOpen] = useState(false);

  return (
    <ControlBarWrapper isTop={!!title}>
      <ControlBarContainer>
        <ControlBarBox>
          {title && (
            <ControlBarTitleBox>
              <BackButton action={backButtonAction} data-testid="back-btn" /> {title}
            </ControlBarTitleBox>
          )}
          {leftButton && <ControlButton {...leftButton} />}
          {rightButtons && (
            <ControlBarButtonsBox>
              {rightButtons.map((button, index) => (
                <ControlButton key={index} {...button} />
              ))}
            </ControlBarButtonsBox>
          )}
          {withKpiButton && (
            <Button
              data-id="kpi-formulas"
              variant="outlined"
              onClick={() => setIsFormulasModalOpen(true)}
            >
              {t('kpiFormulas')}
            </Button>
          )}
        </ControlBarBox>
        <KpiFormulasModal
          open={isFormulasModalOpen}
          handleClose={() => setIsFormulasModalOpen(false)}
        />
      </ControlBarContainer>
    </ControlBarWrapper>
  );
};
